module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/2x2-flatpack-mobile-07c65d23eb1245c0148562b1d425a980.png";